import { IBaseResponse } from "@nkr/models/base-response";
import { IObjectResponse, IArrayResponse } from "@nkr/store/application";
import { AuthActionCreators, IGet } from "@nkr/store/authorization";
import { IApplicationState } from "@nkr/store/index";
import moment from "moment";
import { Dispatch } from "react-redux";

export interface IDonorsProtectedReportDetail<T> {
    startDate: string,
    endDate: string,
    data: T[]
}

export interface IDonorsProtectedReport {
    centerId: number,
    centerAlias: string,
    monthEnd: string,
    kidneyDonorsProtected: number,
    kidneyDonorsFullyProtected: number,
    kidneyDonorsTotal: number,
    liverDonorsProtected: number,
    liverDonorsTotal: number
}

export const ActionsReportDonorsProtected = {

    getDonorsProtected: (centerId: number, endDate: string) => (dispatch: Dispatch<IApplicationState>): Promise<IObjectResponse<IDonorsProtectedReportDetail<IDonorsProtectedReport>>> => {
        var options = {
            url: `${__API__}/center/${centerId}/report/donors-protected?endDate=${endDate}`
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IObjectResponse<IDonorsProtectedReportDetail<IDonorsProtectedReport>>) => {
            return Promise.resolve(response);
        });
    }

};